// extracted by mini-css-extract-plugin
module.exports = {"neutralizer":"neutralizerStyles_neutralizer__LsEBQ","flex":"neutralizerStyles_flex__5Xbqb"};